import { Field, Schema } from "../../services/squidex/index";
import { SchemaMetadataModel } from "../../services/akita/schema-metadata-schema/schema-metadata.model";

export class FieldReferenceModel  {
  field: Field;
  schemaId : string;
  schemaDefinition: Schema;
  schemaMetadata: SchemaMetadataModel;
  selectedValue : any;
  referenceFieldValues: any;
  selectedContent: any;
  control : any;
}
